<div id="document-form" *ngIf="templateView==1">
    <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.DOCUMENT_FORMS" | translate }}</h2>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.DOCUMENT_FORMS" | translate }}</h3>
            </div>
        </div>
    </div>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="form-group row mx-5 my-5  justify-content-md-left">
                <div class="col-md-12 mb-5">
                    <form
                    [formGroup]="filterDocumentForm"
                    (ngSubmit)="submitFilterDocument(loadingModal)"
                    >
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="sr-only">{{ "GENERAL.BY_DOCUMENT_NAME" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'GENERAL.BY_DOCUMENT_NAME' | translate }}" formControlName="inputDocumentName" name="inputDocumentName">
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group mb-0">
                                    <button [disabled]="activeSubmitFilterDocument" type="submit" class="btn btn bg-success text-white font-weight-boldest  mr-2" >{{ "INPUT.FILTER" | translate }}</button>
                                    <button type="reset" class="btn btn-default text-dark-50 font-weight-boldest ">{{ "INPUT.RESET" | translate }}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="row">

        

        <div *ngFor="let document of documentFormService.items$ | async; let i = index" class="col-md-3">
            <div class="card card-custom card-stretch gutter-b" (click)="clickDocumentView(document.IdFormulario, loadingModal)">
                <div class="card-body d-flex p-0">
                    <div class="flex-grow-1 bg-white p-5 pb-5 card-rounded flex-grow-1 bgi-no-repeat" style="background-position: calc(100% + 0.5rem) bottom;background-size: 35% auto;">
                        <p class="text-center"><i class="fa fa-file-alt icon-5x text-success"></i></p>
                        <p class="text-dark text-center pt-10 pb-5 font-size-h4 font-weight-bolder line-height-lg">{{ document.Formulario }}</p>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>


<div class="loadingModal">
    <ng-template #loadingModal let-c="close" let-d="dismiss">
        <div class="modal-body">
            <div class="loading-totalesModal">
                <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
            </div>
        </div>
    </ng-template>
</div>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        {{ message }}
      </div>
    </div>
  </ng-container>
</ng-template>